import type { KeyOf } from "@mops/i18n-v1";
import { tx } from "../i18n";

type TxKey = KeyOf<typeof tx>;

/* ══ 도움말(t-in-port-help) ══
   화면별 절은 **그 화면의 리드 문장을 그대로 다시 쓴다**(한 문장 = 한 키). 리드가 없는 화면만 `help.sec.*` 에 한 줄을 둔다.
   (?) → 도움말 절 연결 규칙은 하나다: 제목줄 (?) 판의 끝에 「도움말에서 더 보기」가 서고 `#/help?s=<절 id>` 로 간다.
   어느 화면이 어느 절인가는 아래 표의 `route` 한 곳이 정한다 — 화면이 절 id 를 따로 들지 않는다. */

export type HelpSection = { id: string; route: string; title: TxKey; body: TxKey; admin?: boolean };

export const HELP_SECTIONS: HelpSection[] = [
  { id: "dash", route: "/", title: "nav.dashboard", body: "dash.lead" },
  { id: "board", route: "/board", title: "nav.board", body: "help.sec.board" },
  { id: "queue", route: "/queue", title: "nav.queue", body: "queue.lead" },
  { id: "graph", route: "/graph", title: "nav.graph", body: "graph.lead" },
  { id: "milestones", route: "/milestones", title: "nav.milestones", body: "milestones.lead" },
  { id: "projects", route: "/projects", title: "nav.projects", body: "projects.lead" },
  { id: "session", route: "/session", title: "nav.session", body: "ops.lead" },
  { id: "history", route: "/history", title: "nav.history", body: "hist.lead" },
  { id: "alarms", route: "/alarms", title: "nav.alarms", body: "help.sec.alarms" },
  { id: "tidy", route: "/tidy", title: "nav.tidy", body: "tidy.lead" },
  { id: "servers", route: "/servers", title: "nav.servers", body: "servers.lead" },
  { id: "logs", route: "/logs", title: "nav.logs", body: "help.sec.logs", admin: true },
  { id: "settings", route: "/settings", title: "nav.settings", body: "help.sec.settings" },
  { id: "chores", route: "/chores", title: "nav.chores", body: "chores.lead" },
  { id: "orgs", route: "/orgs", title: "nav.orgs", body: "orgs.lead" },
  { id: "conn", route: "/conn", title: "nav.conn", body: "help.sec.conn", admin: true },
  { id: "git", route: "/git", title: "nav.git", body: "help.sec.git", admin: true },
  { id: "code", route: "/code", title: "nav.code", body: "help.sec.code", admin: true },
  { id: "patterns", route: "/patterns", title: "nav.patterns", body: "pat.lead" },
];

/** 이 화면의 도움말 절 id — 표에 없으면 null(그러면 (?) 판에 「더 보기」를 안 그린다). */
export function helpFor(route: string): string | null {
  return HELP_SECTIONS.find((s) => s.route === route)?.id ?? null;
}

export const helpTitle = (s: HelpSection) => tx(s.title);
export const helpBody = (s: HelpSection) => tx(s.body);
